import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResourcefulService } from './resourcefulService';
import { ModelloCompagnia } from '../models/modello-compagnia';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ModelloCompagniaService extends ResourcefulService<ModelloCompagnia> {
  constructor(private httpClient: HttpClient) {
    super(httpClient, ModelloCompagnia);
  }

  uploadFile(id: number, formData: FormData): Promise<any> {
    return this.httpClient.post(`${this.baseUrl}/${ModelloCompagnia.apiUrl}/${id}/upload`, formData).toPromise();
  }

  downloadFile(id: number): Observable<HttpResponse<Blob>> {
    return this.httpClient.get(`${this.baseUrl}/${ModelloCompagnia.apiUrl}/${id}/download`, {
      responseType: 'blob',
      observe: 'response'
    });
  }

}











//'localhost:4200/api/cga_modelli_compagnia'
